// extracted by mini-css-extract-plugin
export default {"content":"QCAMiWkF5M","copyControl":"iPe3ULM0Gi"};